/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class MonitorReviewsConversationIssueRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.reviews.conversation.issue',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(MonitorReviewsConversationIssueRoute);
